import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {ReduxState} from '../../../../store/types';
import {Formik} from 'formik';
import * as Yup from 'yup';
import GeneralTabForm, {GeneralTabFormType} from './GeneralTab';
import {TabInterface} from '../../../../components/Tabs/Tabs.utils';
import {useTabStyles} from '../../../Extensions/ExtensionDetails/utils';
import i18n from '../../../../services/i18n';
import {accountEmailMaxLength, accountIdMaxLength} from '../../AddNewAccountDialog/AddNewAccountDialog.utils';

const requiredFieldError = i18n.t<string>('errors:common.emptyInput');

const generalTabValidationSchema = Yup.object().shape({
    id: Yup.string().max(accountIdMaxLength).required(requiredFieldError),
    email: Yup.string().max(accountEmailMaxLength).email(i18n.t<string>('errors:common.invalidEmail')),
});

const GeneralTabWrapper: React.VFC<TabInterface> = (
    {
        handleSubmitForm,
        handleInitDataChange,
        handleDirtyChange,
        handleSetSubmitFunc,
        handleSetIsValidFunc,
        isActive,
        tabName,
        tabIndex,
    }) => {
    const classes = useTabStyles();

    const accountDetails = useSelector((state: ReduxState) => state.accounts.accountDetails);
    const isDataLoading = accountDetails?.isFormDataLoading || false;

    const initialValues: GeneralTabFormType = {
        id: accountDetails?.id ?? '',
        email: accountDetails?.email ?? '',
        time_zone_name: accountDetails?.time_zone_name ?? '',
        country: accountDetails?.country ?? '',
        city: accountDetails?.city ?? '',
        baddr1: accountDetails?.baddr1 ?? '',
        zip: accountDetails?.zip ?? '',
        state: accountDetails?.state ?? '',
        activation_date: accountDetails?.activation_date ?? null,
    };

    useEffect(() => {
        if (!isDataLoading && accountDetails) {
            handleInitDataChange?.(initialValues);
            handleSubmitForm?.(initialValues);
        }
    }, [isDataLoading]);

    return (
        <Formik<GeneralTabFormType>
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={generalTabValidationSchema}
            validateOnChange={false}
            onSubmit={(form) => handleSubmitForm?.(form)}
        >
            {() => (
                <GeneralTabForm
                    handleDirtyChange={handleDirtyChange}
                    handleSetSubmitFunc={handleSetSubmitFunc}
                    handleSetIsValidFunc={handleSetIsValidFunc}
                    tabName={tabName}
                    tabIndex={tabIndex}
                />
            )}
        </Formik>
    );
};

export default GeneralTabWrapper;